const dataWork = [
    {
        id: 1,
        numb: '01',
        title: 'Set up your wallet',
        text : 'You need to have a WEB3 wallet, MetaMask, TokenPocket, etc..., as your browser. Login the App with your address',
        active: 'active'
    },
    {
        id: 2,
        numb: '02',
        title: 'Mint your collection',
        text : 'The NFT can be minted as 200 BUSD for each. The first function of our NFT is stacking, more functions are coming...'
    },
    {
        id: 3,
        numb: '03',
        title: "Stack your NFT's",
        text : 'It is our NFTs first function, you can earn BNB when stacking, you can cancel stacking whenever you want'
    },
    {
        id: 4,
        numb: '04',
        title: "Sell Your NFT's",
        text : 'When you do not want to hold the NFT, you can sell it in our marketplace'
    },
]
export default dataWork;